import { parseDateInput } from "factor-lib/forms/DateInput/DateInput";
import { serverDateSerialization } from "factor-lib/utils/dateUtils";

const formatNewBilanDateCloture = (input: string): string =>
    serverDateSerialization(parseDateInput(input)!);

export default formatNewBilanDateCloture;
